// Standalone so `routeURLs` and the router can use these tabs without importing the page itself,
// which would pull the page and its dependencies into the initial bundle.
export enum SYSTEM_SETTINGS_TYPE {
  ROLE = 'role',
  TEAM = 'team',
  USER = 'user',
  ACCOUNT = 'account',
  CONFIGURATION = 'configuration',
}
